import { Injectable } from '@angular/core';
import {
  FalseRecordingsReportClient,
  FalseRecordingsReportParameterDTO,
  FilterCondition,
  FilterDTO,
  FilterOperator,
  PagedResultDTOOfFalseRecordingsReportDTO,
  PagedResultDTOOfUserInfoDTO,
  PagedResultDTOOfZoneDTO,
  SavedReportFileDTO,
  SortDirection,
  UserAccountClient,
  ZoneClient,
} from '../../../../base/models/models.swagger.generated';
import { ClientService } from '../../../../base/services/client/client.service';
import { catchError } from 'rxjs/operators';
import { ErrorType } from '../../../../core/routing/error-types';
import { Observable, of, throwError } from 'rxjs';
import { ToastService } from '../../../../base/services/toast.service';
import { SaveOptions } from '../../reports-footer/save-options';
import { ShowInactiveService } from '../../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../../base/shared/syncfusion/adaptor-service.interface';

@Injectable()
export class FalseRecordingReportService extends ShowInactiveService implements IAdaptorService {
  public falseRecordingsReportParameters: FalseRecordingsReportParameterDTO = new FalseRecordingsReportParameterDTO();

  constructor(private falseRecordingsReportClient: FalseRecordingsReportClient,
              private zoneClient: ZoneClient,
              private userAccountClient: UserAccountClient,
              private clientService: ClientService,
              private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfFalseRecordingsReportDTO> {
    if (!this.falseRecordingsReportParameters.dateRange.startDate || !this.falseRecordingsReportParameters.dateRange.endDate) {
      return of(new PagedResultDTOOfFalseRecordingsReportDTO());
    }
    if (!filters) {
      filters = [];
    }
    if (!sortBy) {
      sortBy = 'Id';
    }
    if (!sortDirection) {
      sortDirection = SortDirection.Descending;
    }
    return this.falseRecordingsReportClient.searchFalseRecordingsReportData(this.clientService.selectedClient.id, this.falseRecordingsReportParameters, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(falseRecordingsReportParameterDTO: FalseRecordingsReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.falseRecordingsReportClient.exportFalseRecordingsReport(
      this.clientService.selectedClient.id,
      saveOptions.exportType,
      saveOptions.saveReport,
      falseRecordingsReportParameterDTO,
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public searchZones(searchText: string): Observable<PagedResultDTOOfZoneDTO> {
    const filterDTOs = [];
    filterDTOs.push(new FilterDTO({
      isComplex: false,
      field: 'Name',
      operator: FilterOperator.Contains,
      value: searchText,
    }));
    return this.zoneClient.searchZones(this.clientService.selectedClient.id, filterDTOs, 0, 9, 'Name', SortDirection.Ascending)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public searchAgents(searchText: string): Observable<PagedResultDTOOfUserInfoDTO> {
    const filterDTOs = [];
    filterDTOs.push(new FilterDTO({
      isComplex: true,
      condition: FilterCondition.Or,
      predicates: [
        new FilterDTO({
          isComplex: false,
          field: 'Firstname',
          operator: FilterOperator.Contains,
          value: searchText,
        }),
        new FilterDTO({
          isComplex: false,
          field: 'Lastname',
          operator: FilterOperator.Contains,
          value: searchText,
        }),
      ],
    }));

    return this.userAccountClient.searchUsers(filterDTOs, 0, 0, 0, 'firstname', SortDirection.Ascending)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

}
